export const StreakSparkIcon: React.FC = () => {
  return (
    <>
      <svg
        className="w-4 h-4 text-white"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 10V3L4 14h7v7l9-11h-7z"
        />
      </svg>
      {/* <img
        alt="Streak Spark logo"
        src="/android-chrome-192x192.png"
        style={{ height: "42px", width: "42px" }}
      ></img> */}
    </>
  );
};
